export default function TermsPage() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <h1>Terms of Service</h1>
      <p><em>Last updated: {new Date().toLocaleDateString()}</em></p>
      
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using Social Crossposter, you agree to be bound by these Terms of Service. 
        If you do not agree with any part of these terms, you may not use our service.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        Social Crossposter is a simple application that enables you to connect your social media 
        accounts (currently Facebook and TikTok) and publish videos directly to them. 
      </p>
      <ul>
        <li><strong>Immediate Publishing Only:</strong> Our service only supports immediate, direct publishing of videos. We do not provide post scheduling, drafting, or inbox management functionalities.</li>
        <li><strong>No Paid Services:</strong> The service is provided as-is without any paid subscriptions or premium features.</li>
      </ul>

      <h2>3. Account Connections and Security</h2>
      <p>
        To use the publishing features, you must authorize Social Crossposter to connect to your Facebook or TikTok accounts via OAuth. 
        We take security seriously: your authorization tokens are securely encrypted at rest. 
        You maintain the right to disconnect these integrations at any point, which will permanently delete your tokens from our active database.
      </p>

      <h2>4. User Content</h2>
      <p>
        You are solely responsible for the video content you upload and publish through our service. 
        Uploaded videos are strictly processed for the purpose of transmission to your selected social platforms. 
        You must ensure that your content complies with the terms and community guidelines of the respective social media networks (Facebook and TikTok).
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        Social Crossposter is provided "as is" and "as available" without warranties of any kind. 
        We are not responsible for any actions taken by third-party platforms (such as Facebook or TikTok) against your accounts, including video removals or account suspensions.
      </p>

      <h2>6. Modifications</h2>
      <p>
        We reserve the right to modify or replace these Terms at any time. Your continued use of the service after any such changes constitutes your acceptance of the new Terms of Service.
      </p>
    </div>
  );
}
